import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./scss/app.scss";
import "./scss/app.scss";
import { CollectionProvider } from "@/context/CollectionContext";
import CollectionCreatePage from "./pages/createCollection";
import SingleCollectionPage from "./pages/collection";
import MainPage from "./pages/mainPage";
import AccountPage from "./pages/account";
import SingleItemPage from "./pages/item";
import ConfirmWalletPage from "./pages/confirmWallet";
import { app_version, masterTonContract } from "./config";
import CreateCollectionPage from "./pages/create-collection";
import CreateCollectionStepPage from "./pages/create-collection-step";
import NFTSMintPage from "./pages/mint";
import OwnerPage from "./pages/owner";
import NftPage from "./pages/nft";
import LeaderBoardPage from "./pages/leaderBoard";
import NotFoundPage from "./pages/404";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import { useWallet, WalletProvider } from "@/context/WalletContext";
import WebApp from "@twa-dev/sdk";
import Version from "./components/atomics/version";
import { getUrlFromMiniAppParam, recoverRefParam } from "./utils/telegram";
import { useTonConnectUI } from "@tonconnect/ui-react";
import { backend } from "./services/backend";
import { connector } from "./functions";
import { sendGtag } from "./utils/stats";
import { LSService } from "./services/storage";
import { questsBackend } from "./services/questsBackend";
import QuestsPage from "./pages/quests";
import { ratingBackend } from "./services/ratingBackend";
import { useTonConnect } from "./hooks/useTonConnect";
import { Address } from "@ton/core";
import ExpGainMessage, {
  ExpGainMessageProps,
} from "./components/atomics/notify-exp-message";

const sesionStorageVisitKey = "visited_first";

const App = () => {
  const [tonConnectUI] = useTonConnectUI();
  const { connected, wallet } = useTonConnect();

  /* 
     Mini app param redirect test
  */
  useEffect(() => {
    const sesionStorageMiniAppKey = "visited_miniapp";

    const params = new URLSearchParams(location.search);
    const miniAppParam = params.get("miniappparam");

    const isMiniAppVisited = sessionStorage.getItem(sesionStorageMiniAppKey);
    console.log("Mini app param:", miniAppParam);
    if (miniAppParam && !isMiniAppVisited) {
      const urlPath = getUrlFromMiniAppParam(miniAppParam);
      const fullPath = `/${urlPath}`;
      const currentPath = `${document.location.pathname}${document.location.search}`;
      console.log("Mini app param scenario:", fullPath);

      if (fullPath !== currentPath) {
        const fullPath = `/${urlPath}`;
        const currentFullPath =
          document.location.pathname + document.location.search;

        if (fullPath !== currentFullPath) {
          const [pathname, queryString] = fullPath.split("?");
          const targetUrl = queryString
            ? `${pathname}?${queryString}`
            : pathname;

          // Prevent infinite redirect
          setTimeout(() => {
            document.location.href = targetUrl;
          }, 0);
        }
      }

      sessionStorage.setItem(sesionStorageMiniAppKey, "1");
    }
  }, []);

  // for notification
  const [expGainMessageProps, setEGMP] = useState<ExpGainMessageProps>();
  const onExpGainClose = () => setEGMP(undefined);

  useEffect(() => {
    const startParam = WebApp.initDataUnsafe?.start_param;
    WebApp.expand();
    WebApp.disableVerticalSwipes();
    // console.log("Platform:", WebApp.platform);

    const path = document.location.pathname;

    if (
      WebApp.platform === "ios" ||
      WebApp.platform === "macos" ||
      WebApp.platform === "weba" ||
      WebApp.platform === "webk"
    ) {
      window.history.pushState(null, "", path);
    }

    connector.onStatusChange(wallet => {
      const startParam = WebApp.initDataUnsafe?.start_param;
      const urlPath = getUrlFromMiniAppParam(startParam || "");
      const ref = recoverRefParam(urlPath);
      if (ref && wallet?.account) {
        backend.registerReferral(wallet.account.address, ref);
      }
    });

    const isVisited = sessionStorage.getItem(sesionStorageVisitKey);

    // Track if we've already processed this specific startParam to prevent infinite loops
    const processedShareKey = "processed_share_param";
    const processedShare = sessionStorage.getItem(processedShareKey);

    if (startParam) {
      const urlPath = getUrlFromMiniAppParam(startParam);
      const fullPath = `/${urlPath}`;
      const currentPath = document.location.pathname + document.location.search;

      // Check if this is a share link
      const hasShareParams = urlPath.includes("share=true");

      // For share links: only navigate if we haven't processed this exact startParam yet
      // For regular links: use the existing isVisited check
      const shouldNavigate = hasShareParams
        ? processedShare !== startParam && fullPath !== currentPath
        : !isVisited && fullPath !== currentPath;

      if (shouldNavigate) {
        // Mark this share param as processed to prevent infinite loop
        if (hasShareParams) {
          sessionStorage.setItem(processedShareKey, startParam);
        }

        const [pathname, queryString] = fullPath.split("?");
        const targetUrl = queryString ? `${pathname}?${queryString}` : pathname;

        // Prevent infinite redirect
        setTimeout(() => {
          document.location.href = targetUrl;
        }, 0);
        sendGtag("tma_url", {
          path: fullPath,
        });
      }

      if (!isVisited) {
        sessionStorage.setItem(sesionStorageVisitKey, "1");
      }
    }

    sendGtag("visit_page", {
      path: document.location.pathname,
    });
  }, []); // Remove pathname dependency to prevent re-triggering

  // notifications
  useEffect(() => {
    if (wallet) {
      const addressStr = Address.parse(wallet).toString();
      ratingBackend
        .getWalletLastNotifyInfo(Address.parse(wallet).toString())
        .then(res => {
          // console.log("Notify:", res);
          if (!res.no) {
            backend
              .getAddressItemBalance(addressStr, "experience")
              .then(res => {
                // only if has an exp
                if (res > 0)
                  setEGMP({
                    className: "absolute egmp",
                    previousExperience: 0,
                    experience: res,
                    onClose: onExpGainClose,
                  });
              });
            ratingBackend.noteUserNotified(addressStr, 1);
          }
        });
    }
  }, [wallet]);

  useEffect(() => {
    /* const timer = setTimeout(() => {
      const authVersion = LSService.getAuthVersion();
      if (!authVersion && tonConnectUI && tonConnectUI.wallet) {
        tonConnectUI.disconnect();
      }
    }, 1000); */

    const timeToCheck = setTimeout(() => {
    backend.checkCookieAuth().then((address) => {
      if (!address) {
          console.log("No cookie auth");
          // tonConnectUI.disconnect();
      }
      console.log("Address from cookie:", address);

    }).catch(console.error)
    }, 10000)
    
    return clearTimeout(timeToCheck)
    // return () => clearTimeout(timer);
  }, [tonConnectUI]);

  return (
    <BrowserRouter>
      <SnackbarProvider anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <WalletProvider>
          <CollectionProvider>
            <Routes>
              <Route
                path="/collection/create"
                element={<CreateCollectionPage />}
              />
              <Route path="/owner/:address" element={<OwnerPage />} />
              <Route
                path="/collection/create/:step"
                element={<CreateCollectionStepPage />}
              />
              <Route
                path="/collection/:collection"
                element={<NFTSMintPage />}
              />
              <Route path="/nft/:id" element={<NftPage />} />
              <Route path="/walletconfirm" element={<ConfirmWalletPage />} />
              <Route
                path="/leaderboard/:order_param"
                element={<LeaderBoardPage />}
              />
              <Route
                path="/leaderboard/:type/:order_param"
                element={<LeaderBoardPage />}
              />
              <Route path="/leaderboard/:type" element={<LeaderBoardPage />} />
              <Route path="/leaderboard" element={<LeaderBoardPage />} />
              <Route path="/item/:item" element={<SingleItemPage />} />
              <Route path="/quests" element={<QuestsPage />} />
              <Route path="/quests/:type" element={<QuestsPage />} />
              <Route path="/" element={<CreateCollectionPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            {expGainMessageProps && <ExpGainMessage {...expGainMessageProps} />}
            <Version version={app_version} />
          </CollectionProvider>
        </WalletProvider>
      </SnackbarProvider>
    </BrowserRouter>
  );
};

export default App;
